import { buildApiActionTypes } from './apiActionTypes';

export const growthStagesConfigActionTypes = {
  SAVE_GROWTH_STAGE_CONFIG: 'SAVE_GROWTH_STAGE_CONFIG'
};

export const saveGrowthStageConfigRequestActionTypes = buildApiActionTypes(
  'SAVE_GROWTH_STAGE_CONFIG_REQUEST'
);
